import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

// 路由组件懒加载
const Login = () => import('@/views/login/Login')
const Layout = () => import('@/layout/Layout')
const Dashboard = () => import('@/views/dashboard/Dashboard')
const SiteSetting = () => import('@/views/site/SiteSetting')
const HotelList = () => import('@/views/hotel/HotelList')
const HotelEdit = () => import('@/views/hotel/HotelEdit')
const StoreList = () => import('@/views/store/StoreList')
const StoreEdit = () => import('@/views/store/StoreEdit')
const MattressCollection = () => import('@/views/mattress/CollectionList')
const MattressCollectionEdit = () => import('@/views/mattress/CollectionEdit')
const AccessoryList = () => import('@/views/mattress/AccessoryList')
const AccessoryEdit = () => import('@/views/mattress/AccessoryEdit')
const BedsteadList = () => import('@/views/mattress/BedsteadList')
const BedsteadEdit = () => import('@/views/mattress/BedsteadEdit')
const MattressList = () => import('@/views/mattress/MattressList')
const MattressEdit = () => import('@/views/mattress/MattressEdit')
// 内容管理
const BannerList = () => import('@/views/content/BannerList')
const BannerEdit = () => import('@/views/content/BannerEdit')
const ArticleList = () => import('@/views/content/ArticleList')
const ArticleEdit = () => import('@/views/content/ArticleEdit')
// 用户管理
const UserList = () => import('@/views/user/UserList')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录', noAuth: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'site-setting',
        name: 'SiteSetting',
        component: SiteSetting,
        meta: { title: '站点配置', icon: 'el-icon-setting' }
      },
      {
        path: 'user',
        name: 'UserManage',
        component: { render: h => h('router-view') },
        meta: { title: '用户管理', icon: 'el-icon-user' },
        children: [
          {
            path: 'list',
            name: 'UserList',
            component: UserList,
            meta: { title: '用户列表', icon: 'el-icon-s-custom' }
          }
        ]
      },
      {
        path: 'content',
        name: 'ContentManage',
        component: { render: h => h('router-view') },
        meta: { title: '内容管理', icon: 'el-icon-document' },
        children: [
          {
            path: 'banner/list',
            name: 'BannerList',
            component: BannerList,
            meta: { title: 'Banner管理', icon: 'el-icon-picture' }
          },
          {
            path: 'banner/add',
            name: 'BannerAdd',
            component: BannerEdit,
            meta: { title: '添加Banner', activeMenu: '/content/banner/list' }
          },
          {
            path: 'banner/edit/:id',
            name: 'BannerEdit',
            component: BannerEdit,
            meta: { title: '编辑Banner', activeMenu: '/content/banner/list' },
            props: true
          },
          {
            path: 'article/list',
            name: 'ArticleList',
            component: ArticleList,
            meta: { title: '文章管理', icon: 'el-icon-reading' }
          },
          {
            path: 'article/add',
            name: 'ArticleAdd',
            component: ArticleEdit,
            meta: { title: '添加文章', activeMenu: '/content/article/list' }
          },
          {
            path: 'article/edit/:id',
            name: 'ArticleEdit',
            component: ArticleEdit,
            meta: { title: '编辑文章', activeMenu: '/content/article/list' },
            props: true
          }
        ]
      },
      {
        path: 'hotel',
        name: 'HotelManage',
        component: { render: h => h('router-view') },
        meta: { title: '酒店管理', icon: 'el-icon-house' },
        children: [
          {
            path: 'list',
            name: 'HotelList',
            component: HotelList,
            meta: { title: '酒店列表', icon: 'el-icon-s-order' }
          },
          {
            path: 'add',
            name: 'HotelAdd',
            component: HotelEdit,
            meta: { title: '添加酒店', activeMenu: '/hotel/list' }
          },
          {
            path: 'edit/:id',
            name: 'HotelEdit',
            component: HotelEdit,
            meta: { title: '编辑酒店', activeMenu: '/hotel/list' },
            props: true
          }
        ]
      },
      {
        path: 'store',
        name: 'StoreManage',
        component: { render: h => h('router-view') },
        meta: { title: '门店管理', icon: 'el-icon-office-building' },
        children: [
          {
            path: 'list',
            name: 'StoreList',
            component: StoreList,
            meta: { title: '门店列表', icon: 'el-icon-s-shop' }
          },
          {
            path: 'add',
            name: 'StoreAdd',
            component: StoreEdit,
            meta: { title: '添加门店', activeMenu: '/store/list' }
          },
          {
            path: 'edit/:id',
            name: 'StoreEdit',
            component: StoreEdit,
            meta: { title: '编辑门店', activeMenu: '/store/list' },
            props: true
          }
        ]
      },
      {
        path: 'mattress',
        name: 'MattressManage',
        component: { render: h => h('router-view') },
        meta: { title: '产品管理', icon: 'el-icon-s-goods' },
        children: [
          {
            path: 'list',
            name: 'MattressList',
            component: MattressList,
            meta: { title: '床垫列表', icon: 'el-icon-s-management' }
          },
          {
            path: 'add',
            name: 'MattressAdd',
            component: MattressEdit,
            meta: { title: '添加床垫', activeMenu: '/mattress/list' }
          },
          {
            path: 'edit/:id',
            name: 'MattressEdit',
            component: MattressEdit,
            meta: { title: '编辑床垫', activeMenu: '/mattress/list' },
            props: true
          },
          {
            path: 'collection/list',
            name: 'MattressCollectionList',
            component: MattressCollection,
            meta: { title: '系列管理', icon: 'el-icon-collection' }
          },
          {
            path: 'collection/add',
            name: 'MattressCollectionAdd',
            component: MattressCollectionEdit,
            meta: { title: '添加系列', activeMenu: '/mattress/collection/list' }
          },
          {
            path: 'collection/edit/:id',
            name: 'MattressCollectionEdit',
            component: MattressCollectionEdit,
            meta: { title: '编辑系列', activeMenu: '/mattress/collection/list' },
            props: true
          },
          {
            path: 'bedstead/list',
            name: 'BedsteadList',
            component: BedsteadList,
            meta: { title: '床架管理', icon: 'el-icon-set-up' }
          },
          {
            path: 'bedstead/add',
            name: 'BedsteadAdd',
            component: BedsteadEdit,
            meta: { title: '添加床架', activeMenu: '/mattress/bedstead/list' }
          },
          {
            path: 'bedstead/edit/:id',
            name: 'BedsteadEdit',
            component: BedsteadEdit,
            meta: { title: '编辑床架', activeMenu: '/mattress/bedstead/list' },
            props: true
          },
          {
            path: 'accessory/list',
            name: 'AccessoryList',
            component: AccessoryList,
            meta: { title: '配件管理', icon: 'el-icon-dessert' }
          },
          {
            path: 'accessory/add',
            name: 'AccessoryAdd',
            component: AccessoryEdit,
            meta: { title: '添加配件', activeMenu: '/mattress/accessory/list' }
          },
          {
            path: 'accessory/edit/:id',
            name: 'AccessoryEdit',
            component: AccessoryEdit,
            meta: { title: '编辑配件', activeMenu: '/mattress/accessory/list' },
            props: true
          }
        ]
      }
    ]
  },
  // 404页面
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start()
  
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 斯林百兰管理系统` : '斯林百兰管理系统'
  
  // 判断是否登录
  const token = localStorage.getItem('token')
  
  if (to.meta.noAuth) {
    // 不需要登录的页面
    next()
  } else if (token) {
    // 已登录状态
    next()
  } else {
    // 未登录状态，跳转到登录页
    next('/login')
  }
})

router.afterEach(() => {
  // 关闭进度条
  NProgress.done()
})

export default router 